module.exports = __webpack_public_path__ + "static/img/logo7.b503214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo7.png
// module id = yAs+
// module chunks = 1